export const InteractionIcon = ({ color = 'currentColor', ...props }: JSX.IntrinsicElements['svg']) => {
  return (
    <svg width='15' height='15' viewBox='0 0 15 15' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle cx='3.75' cy='3.75' r='3' stroke={color} strokeWidth='1.5' />
      <circle opacity='0.75' cx='11.25' cy='11.25' r='3' stroke={color} strokeWidth='1.5' />
      <path opacity='0.25' d='M14.25 6.75C14.25 3.43629 11.5637 0.75 8.25 0.75' stroke={color} strokeWidth='1.5' />
      <path opacity='0.25' d='M0.75 8.25C0.75 11.5637 3.43629 14.25 6.75 14.25' stroke={color} strokeWidth='1.5' />
    </svg>
  );
};
